import React, { Component } from "react";
import PolicyView from "../views/PolicyView";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../state/actions/actions";
import { withRouter } from "react-router-dom";

const mapStateToProps = state => {
  return {
    data: state.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      actions,
      dispatch
    )
  };
};

class PolicyContainer extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <PolicyView {...this.props} />
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PolicyContainer)
